import React, { useState } from "react";
import TimelineTweet from "../TimelineTweet/TimelineTweet";

import { useSelector } from "react-redux";
import axios from "axios";

const MainTweet = () => {
    const [tweetText, setTweetText] = useState("");

    const { currentUser } = useSelector((state) => state.user);

    // console.log("current", currentUser); 

    const url = "https://twitter-backend-v0gs.onrender.com/api"

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const accessToken = localStorage.getItem('accessToken');


            const submitTweet = await axios.post(`${url}/tweets`, {
                userId: currentUser._id,
                description: tweetText,
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`, // Include the access token in the "Authorization" header
                },
            });
            window.location.reload(false);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div>
            {currentUser && (
                <p className="font-bold pl-2 my-2">{currentUser.username}</p>
            )}

            <form className="border-b-2 pb-6">
                <textarea
                    onChange={(e) => setTweetText(e.target.value)}
                    type="text"
                    placeholder="What's happening"
                    maxLength={280}
                    className="bg-slate-200 rounded-lg w-full p-2"
                ></textarea>
                <button
                    onClick={handleSubmit}
                    className="bg-blue-500 text-white py-2 px-4 rounded-full ml-auto"
                >
                    Tweet
                </button>
            </form>
            <TimelineTweet />
        </div>
    );
};

export default MainTweet;